import React, { useEffect, useState } from 'react';
import ContractsSearchForm from 'components/molecules/contracts_search_form';
import ContractList from 'components/organisms/contract_list';
import { getContract } from 'store/modules/contracts_store/actions';
import { useDispatch, useSelector } from 'react-redux';
import BlockedSubscription from 'components/molecules/blocked_subscription';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import tabId from 'services/tabId';
import BlockedSubscriptionRepresentant from 'components/molecules/blocked_subscription_representant';

const Contracts: React.FC = () => {
  const dispatch = useDispatch();

  const [page, setPage] = useState<number>(1);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const allowedSaleSituations = ['Ativa', 'Em Analise'];

  useEffect(() => {
    const companyId = profile?.represented?.find(
      (company) => company.id === profile.currentCompany[tabId()],
    )?.id;
    dispatch(getContract({ page, companyId }));
  }, []);

  return (
    <div className="page-container">
      {!profile.representant &&
        (!allowedSaleSituations.includes(profile.sale_situation) || profile.paralyzed) && (
          <BlockedSubscription paralyzed={profile.paralyzed} />
        )}
      {profile.representant &&
        profile.currentCompany[tabId()] !== profile.clientId &&
        profile.represented.filter((company) => company.id === profile.currentCompany[tabId()])[0]
          ?.paralisado &&
        allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) && <BlockedSubscriptionRepresentant />}
      {profile.representant &&
        profile.currentCompany[tabId()] !== profile.clientId &&
        !allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) && <BlockedSubscriptionRepresentant />}
      {((!profile.representant &&
        !profile.paralyzed &&
        allowedSaleSituations.includes(profile.sale_situation)) ||
        (profile.representant &&
          allowedSaleSituations.includes(
            profile?.represented?.filter(
              (company) => company.id === profile.currentCompany[tabId()],
            )[0]?.sale_situation_name,
          ) &&
          !profile.represented.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.paralisado)) && (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <ContractsSearchForm page={page} setPage={setPage} />
            </div>
            <div className="col-md-9 pr-md-0">
              <ContractList setPage={setPage} page={page} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export { Contracts };
